import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap';


import Editor from './editor';

import './styles.css'

class Wording extends Component {
  render() {
    const {wording, fetched, fetching} = this.props;
    return (
      <Grid bsClass="container" fluid className="editor">
        <Row>
          <Col md={12}>
              {(!fetching || fetched) && <Editor content={wording}
                    field="deep.admin_upsell_popup_save.wording" />}
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
    return {
        wording: state.deep.admin_upsell_popup_save.wording,
        fetched: state.upsellPopups.fetched,
        fetching: state.upsellPopups.fetching,
    };
};

export default connect(mapStateToProps)(Wording);



// WEBPACK FOOTER //
// ./src/components/admin/promotions/upsell_popups/add/wording-editor.jsx